<template>
  <div class="wrapper-logo">
    <div v-if="getIsMobile && getLinkGame" class="tooltip-mobile">
      ↓ {{ $t('welcome_popup.achievements.transition') }}
      ↓
    </div>
    <a :href="linkGameFinal" :style="linkStyle" class="logo-link">
      <div class="wrapper-img">
        <div v-if="linkGameTournamentOrAchievement" class="wrapper-img-hover">
          <span>{{ $t('welcome_popup.achievements.transition') }}</span>
        </div>
        <img v-if="getGameId" :src="linkImageGame" alt="logoGames" />
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import Vue from 'vue';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'LogoTransition',
  computed: {
    ...mapGetters(['getIsMobile', 'getLinkGame', 'getLinkGameTournament', 'getGameId']),
    linkGameTournamentOrAchievement(): string {
      return this.getLinkGame || this.getLinkGameTournament;
    },
    linkGameFinal(): string {
      return this.linkGameTournamentOrAchievement ?? 'javascript:void(0);';
    },
    linkImageGame(): string {
      return `${Utils.getLinkForGameLogo}g${this.getGameId}.jpg`;
    },
    linkStyle(): { cursor: string } {
      return {
        cursor: this.linkGameTournamentOrAchievement ? 'pointer' : 'auto'
      };
    }
  }
});
</script>

<style scoped>
.wrapper-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: 'myriadpro-boldcond', sans-serif;
  font-size: 20px;
}

.wrapper-img {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.wrapper-img-hover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  opacity: 0;
  font-size: 30px;
}

.wrapper-img-hover:hover {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}

.logo-link img {
  width: 200px;
}
</style>
